import { get, patch, post, destroy } from './httpClient'

export const apiAllProduct = (query) => get('/product', { ...query })
export const apiUpdateProduct = (object, id) => patch(`/product/update/${id}`, object)
export const apiSearchProduct = (object) => get('/product', object)

export const getProductType = (query) => get('/product-type', query)
export const createProductType = (data) => post('/product-type/create', data)
export const updateProductType = (object, id) => patch(`/product-type/update/${id}`, object)
export const deleteProductType = (id) => destroy('/product-type/delete/' + id)

export const apiProductSeller = (query) => get('/saleproduct/getsaleproduct', { ...query })
export const apiUpdateProductStore = (object, id) =>
  patch(`/saleproduct/updatesaleproduct/${id}`, object)
export const apiProductCategory = () => get('/category/getproductincategory')
export const getProducts = (query) => get('/product', query)
export const getAttributes = (query) => get('/product/getattribute', query)
export const addProduct = (body) => post('/product/create', body)
export const updateProduct = (body, id) => patch('/product/update/' + id, body)
export const deleteProduct = (ids) => destroy('/product/delete', { product_id: ids })
export const importProduct = (formData) => post('/product/importfile', formData)
export const getTagsProduct = () => get('/product/tag/all')
